<template>
<w-sliding-popup ref="slidingPopup" title="맵 이름 수정" width="350px">
  <div slot="content">
    <el-form :model="formData" :rules="rules" label-width="120px" ref="mapNameForm" label-position="top">
      <el-form-item label="맵 이름" prop="mapName">
        <el-input v-model="formData.mapName" :maxlength="255"></el-input>
      </el-form-item>
    </el-form>
  </div>

  <div slot="footer" type="flex" justify="end">
    <el-button size="small" type="solid" @click="onSaveClick">저장</el-button>
    <el-button size="small" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import MapAPI from '@/api/topologymap/common';

import Base from '@/mixins/topologymap/base';

import { Q, MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WMapLabelEditPopup',
  components: {},
  mixins: [Base],
  data() {
    return {
      orgData: null,
      formData: {
        mapName: '',
      },
      rules: {
        mapName: [
          {
            required: true,
            message: '맵 이름을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(params) {
      this.resetForm();
      this.initFormData(params.model);

      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 저장 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSaveClick() {
      this.validateForm(); // 유효성 체크
    },
    /**
     * 유효성 체크
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    validateForm() {
      if (this.$refs.mapNameForm) {
        this.$refs.mapNameForm.validate((valid) => {
          if (valid) {
            // 유효성 체크를 통과하면 저장
            this.save();
          }
        });
      }
    },
    /**
     * 입력 폼 리셋
     * @author KangBonghun(toto1323)
     */
    resetForm() {
      if (this.$refs.mapNameForm) {
        this.$refs.mapNameForm.resetFields();
      }
    },
    /**
     * 폼 데이터를 초기화한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    initFormData(model) {
      this.orgData = model;
      this.formData = {
        mapId: model.mapId,
        mapName: model.label,
      };
    },
    /**
     * 저장
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    save() {
      const mapId = this.formData.mapId;
      const mapName = this.formData.mapName;

      MapAPI.updateTopologymapName(mapId, mapName).then((response) => {
        const result = response.data;

        if (result.success) {
          this.$message.success('맵 이름을 저장하였습니다.');

          this.syncMapName(mapId, mapName);

          this.close();
        }
      });
    },
    /**
     * 변경 된 맵에 관련된 부분에 맵 이름을 동기화한다.
     * @author KangBonghun(toto1323)
     * @param  {Number} mapId   맵 아이디
     * @param  {String} mapName 맵 이름
     */
    syncMapName(mapId, mapName) {
      const graph = MapInfo.getInstance(this).getGraph();
      const topologymapModel = graph.topologymapModel;

      // 맵 트리에 이름 반영
      this.orgData.label = mapName;

      // 맵 모델에 이름 변경
      if (topologymapModel.mapId === mapId) {
        topologymapModel.label = mapName;
      }

      // 맵에 그려진 하위맵에 이름 변경
      graph.graphModel.toDatas().forEach((model) => {
        if (model instanceof Q.SubTopologymapModel && model.get('mapId') === mapId) {
          model.set('mapName', mapName);
        }
      });

      // 토폴로지맵 모델의 하위멥에 이름 변경
      topologymapModel.subTopologymapModels.forEach((model) => {
        if (model.mapId === mapId) {
          model.mapName = mapName;
        }
      });
    },
  },
};
</script>

<style module>
.v-middle {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/MapLabelEditPopup.vue